import PedidoNovo from './PedidoNovo';

export default PedidoNovo;